/* tslint:disable:no-shadowed-variable */
import { ModuleNames } from '@/store/module-names'
import { AppState } from './types'
import { AppMutationNames } from './keys'
import { getters } from './getters'

const state: AppState = {
  userId: '',
  userFirstName: '',
  userLastName: '',
  userRoles: [],
}

const mutations = {
  [AppMutationNames.updateUserId](state, payload: string): void {
    state.userId = payload
  },
  [AppMutationNames.updateUserLastName](state, payload: string): void {
    state.userLastName = payload
  },
  [AppMutationNames.updateUserFirstName](state, payload: string): void {
    state.userFirstName = payload
  },
  [AppMutationNames.updateUserRoles](state, payload: string[]): void {
    state.userRoles = payload
  },
}

const actions = {}

export default {
  name: ModuleNames.patient,
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
